angular.module('impactx.search').service('ProductItemService', [
    'ProductImageGalleryService',
    '$redirect',
    ProductItemService
]);

function ProductItemService(ProductImageGalleryService, $redirect) {

    function openGallery(event, product) {
        if (event) {
            event.stopPropagation();
        }

        ProductImageGalleryService.imageExists(product.imageUrl).then(function () {
            ProductImageGalleryService.openGallery(event, product);
        }, function () {
            redirectToDetails(product);
        });
    }

    function redirectToDetails (product, vCatId, highlightSearchText) {
        if (product.isCompilationArticle) {
            $redirect.redirectTo(null, "compilation/" + product.id);
        }
        else if (product.isUnite) {
            $redirect.redirectTo(null, "productunite/" + product.catalogId + (highlightSearchText ? "/true" : "") + "?externalId=" + encodeURIComponent(product.externalId));
        }
        else {
            // fall back to the view the backend resolved for this product (search results are not
            // bound to a single catalog, so no vCatId is passed in there)
            var targetVCatId = vCatId ? vCatId : (product.vcatalog ? product.vcatalog.id : null);
            $redirect.redirectTo(null, "productredirect/" + product.id + "/" + (targetVCatId ? targetVCatId : "0") + (highlightSearchText ? "/true" : ""));
        }
    }

    return {
        openGallery: openGallery,
        redirectToDetails: redirectToDetails,
    };
}